import { query } from '@angular/animations';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router, UrlTree } from '@angular/router';

@Component({
    selector: 'app-confirm-campaign-creation-modal',
    templateUrl: './confirm-campaign-creation-modal.component.html',
    styleUrls: ['./confirm-campaign-creation-modal.component.scss']
})
export class ConfirmCampaignCreationModalComponent implements OnInit {
    public constructor(
        private router: Router,
        public dialogRef: MatDialogRef<ConfirmCampaignCreationModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnInit(): void {}

    public onCancel(): void {
        this.dialogRef.close();
        this.data.onCancel();
    }

    public navigateToSummary(): void {
        let urlTree: UrlTree;
        urlTree = this.router.createUrlTree([`/campaign/step-5/${this.data.campaign._id}`]);
        let params = '';

        if (this.data.editMode) {
            params = '?preview=true&edit-mode=true';
        }

        if (this.data.partialEditMode) {
            params = '?partial-edit-mode=true';
        }

        if (this.data.liveEditMode) {
            params = '?live-edit-mode=true';
        }

        this.router.navigateByUrl(urlTree + params);

        this.dialogRef.close();
    }
}
